module.exports = __webpack_public_path__ + "static/media/wizard-staff.3e6091b9.svg";